<template>
    <div class="fixed inset-0 z-50 transition overflow-y-none overscroll-none" v-if="show">
        <div class="w-full min-h-screen bg-white">
            
            <!-- Gradient Bar -->
            <div class="w-full h-2 bg-gradient-to-r from-primary-500 via-tertiary-500 to-secondary-500"></div>
            
            <div class="flex flex-col items-stretch w-full h-full max-w-screen-md mx-auto">


                <!-- Nav Top -->
                <div class="w-full container-nav">
                    <div class="flex items-center justify-between">
                        
                        <!-- Logo -->
                        <a href="/">
                            <span class="sr-only">{{ siteName }}</span>
                            <img class="w-auto h-8 md:h-12" src="@/assets/icons/logo-lw/light.svg" alt="Logo">
                        </a>

                        <!-- Close Button -->
                        <button aria-label="Close Mobile Nav" @click="closeModal" class="cursor-pointer text-neutral-800 hover:text-neutral-700">
                            <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M5 19L19 5M5 5L19 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        
                    </div>
                </div>

                <!-- Nav Body -->
                <div class="w-full mt-8 container-nav">
                    <nav class="flex flex-col items-stretch gap-4">

                        <!-- Navigation -->
                        <a @click="closeModal" v-for="item in nav_items" :key="item.id" :title="item.description" :aria-label="item.description" :href="item.url" class="btn btn-lg btn-link btn-neutral body-2xl">
                            {{ item.title }}
                        </a>

                        <!-- Secondary CTA -->
                        <a class="btn btn-lg body-2xl btn-link btn-neutral" target="_blank" href="../../files/menu.pdf">View Menu</a>

                        <!-- Main CTA -->
                        <a class="btn btn-lg body-2xl btn-link btn-primary" target="_blank" href="https://goodeats.io/LATINWAY">Order now</a>

                        <!-- Social Media -->
                        <div class="grid pt-2 place-items-center">
                            <cta-socials />
                        </div>

                        <!-- Contact Details -->
                        <div class="flex flex-col items-center gap-4 pt-4">
                            
                            <cta-phone />

                            <cta-email />

                        </div>

                    </nav>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>

    import CtaPhone from '../components/cta/CtaPhone';
    import CtaEmail from '../components/cta/CtaEmail';
    import CtaSocials from '../components/cta/CtaSocials';

    export default {
        
        name: 'Nav-Modal',

        components: {
            CtaPhone,
            CtaEmail,
            CtaSocials
        },
        
        // Modal Properties
        props: {
            nav_items: Array,
            show: Boolean
        },

        // Modal Closing Function
        methods: {
            closeModal() {
                this.$emit('close');
            }
        }
    };
</script>